import KeyboardRow from "./KeyboardRow";

export default function Keyboard({yellowCharacters, greenCharacters, greyCharacters,handleKeyUp}) {
    const rows = [
        ["q","w","e","r","t","y","u","i","o","p"],
        ["a","s","d","f","g","h","j","k","l"],
        ["Enter","z","x","c","v","b","n","m","Backspace"]
    ]

    return (
        <div className="flex flex-col  gap-2 justify-center items-center w-fit mx-auto">
            {rows.map((row,index)=> <KeyboardRow row={row}  key={index} yellowCharacters={yellowCharacters} handleKeyUp={handleKeyUp} greyCharacters={greyCharacters}  greenCharacters={greenCharacters}/>)}
        </div>
    )
}